import React,{useContext} from 'react';
import './App.css';
import Header from './components/header';
import Body from './components/body';
import Footer from './components/footer';
import Home from "./views/Home";
import Contact from './views/contact';
import Wrapper from './views/wrapper';
import About from './views/About';
import Error from './Error';
import MyWorks from './views/MyWorks';
import aboutImageViewer from './views/aboutImageViewer';


import { 
  BrowserRouter as Router, 
  Route, 
  Link, 
  Switch 
} from 'react-router-dom';
import ImageViewer from './views/imageViewer';

function App() {
  return (
   <Switch>
    <div className="App">
    {/* Routes */}
    <Route path="/" component={Wrapper} exact />
     <Route path="/contact" component={Contact} />
     
     <Route path="/myWorks" component={MyWorks} />
     <Route path="/about" component={About} />

     <Route path="/imageViewer" component={ImageViewer} />
     <Route path="/aboutImageViewer" component={aboutImageViewer} />

     <Route path="/undefined" component={Error} />
     
    </div>
    </Switch>
  );
}

export default App;
